import { Dialog as MUIDialog } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(MUIDialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: '0 24px 16px',
  },
  '& .MuiDialogTitle-root': {
    padding: '16px 24px',
    fontSize: '2.0rem',
    fontWeight: 500,
    lineHeight: '3.2rem',
    color: '#333333',
    letterSpacing: '0.15px',
  },
  '& .MuiDialogActions-root': {
    padding: '24px',
  },
}));
